import {AppConfig} from './app.config-definition';

declare let ENV: any;

export const APP_CONFIGURATIONS: AppConfig & { $$init: boolean } = {
    $$init: false,

    isProduction: ENV === 'prod',
    recaptchaSiteKey: undefined,
    homePageUrl: undefined,
    newAccountCreationUrl: undefined,

    externalPayments: {
        beneficiaryAddressDetailsOptional: false
    },

    analytic: {
        mixpanel: {enabled: false},
        ga: {enabled: false},
        gtm: {enabled: false}
    },

    support: {
        phone: undefined,
        email: undefined
    },

    newAccountButton: {
        enabled: true
    },

    survey: {enabled: false},

    sidebar: {
        tac: {enabled: false}
    },

    registration: {
        tacUrl: undefined,
        prohibitedActivitiesUrl: undefined,
        delegateTo: {},
        providerTac: {
        },
        requireAuthorizedSignatoryIDDocumentsUploading: true,
        fileUpload: {
            passport: {
                allowedMimeTypes: {
                    'application/pdf': '.pdf',
                    'image/png': '.png',
                    'image/jpeg': '.jpeg',
                },
                allowedMaxFileSize: 52428800,
                allowedMaxCountAttachments: 50
            },
            selfie: {
                allowedMimeTypes: {
                    'application/pdf': '.pdf',
                    'image/png': '.png',
                    'image/jpeg': '.jpeg',
                },
                allowedMaxFileSize: 52428800,
                allowedMaxCountAttachments: 50
            },
            address: {
                allowedMimeTypes: {
                    'application/pdf': '.pdf',
                    'image/png': '.png',
                    'image/jpeg': '.jpeg',
                    'application/msword': '.doc',
                    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': '.docx',
                },
                allowedMaxFileSize: 52428800,
                allowedMaxCountAttachments: 50
            },
            documents: {
                allowedMimeTypes: {
                    'application/pdf': '.pdf',
                    'image/png': '.png',
                    'image/jpeg': '.jpeg',
                    'application/msword': '.doc',
                    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': '.docx',
                },
                allowedMaxFileSize: 52428800,
                allowedMaxCountAttachments: 50
            },
            proof: {
                allowedMimeTypes: {
                    'application/pdf': '.pdf',
                    'image/png': '.png',
                    'image/jpeg': '.jpeg',
                    'application/msword': '.doc',
                    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': '.docx',
                },
                allowedMaxFileSize: 52428800,
                allowedMaxCountAttachments: 50
            }
        }
    },

    freshchat: {
        enabled: false,
        vendor: undefined
    },

    ctaButton: {
        enabled: false,
        url: undefined,
        tooltipEnabled: false,
        tooltipEmail: undefined
    },

    identification: {
        appStoreUrl: undefined,
        playMarketUrl: undefined
    },

    validation: {
        urlPattern: '^((http|https)://)?[-a-zA-Z0-9@:%._\\+~#=]{2,256}\\.[a-z]{2,10}\\b([-a-zA-Z0-9@:%_\\+.~#?&//=]*)$'
    },

    twoFactorAuth: {
        signInHelpUrl: undefined
    },

    onlineTransaction: {
        expireTime: 30
    },

    loginFooter: {
        enabled: true,
        tacUrl: undefined,
        privacyUrl: undefined
    },

    massPaymentTemplateFile: {
        urlFile: '/static/Valid_payment.csv'
    },

    card: {
        details: {
            closeTimeoutSec: 30
        },
        history: {
            limits: {
                dateRange: 89
            }
        }
    }
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/clients/app/config/app.config-default.ts